import { useUserContext } from "../components/UserContextProvider";

export function useTranslation() {
    const con = useUserContext();

    function t(key: string, ...args: (string | number)[]): string {
        let text = con?.user().language.values[key] ?? key;
        for (let i = 0; i < args.length; i++) {
            text = text.replace(`{${i}}`, String(args[i]));
        }
        return text;
    }

    // The language object is the locale JSON itself and carries only its display name, not a code.
    const langCode = () => con?.user().language?.name === "English" ? "en" : "de";

    return { t, langCode };
}
